import { cn } from '@/utils';
import { useMemo } from 'react';
import { inlineLink } from './Poll.css';
import type { PollChoiceType, PollStyle } from './Poll.types';

interface Props {
  choice: PollChoiceType;
  pollStyle: PollStyle;
  isLast: boolean;
}

export const PollChoice = ({ choice, pollStyle, isLast }: Props) => {
  const isInline = pollStyle === 'inline';

  const style = useMemo(() => {
    if (pollStyle !== 'unstyled') {
      return { color: 'inherit', textDecoration: 'underline' };
    }
    return { color: 'inherit' };
  }, [pollStyle]);

  return (
    <li className={cn(inlineLink, isInline && 'flex gap-2')}>
      <a
        data-skip-tracking="true"
        rel="noopener noreferrer nofollow"
        style={style}
        target="_blank"
        href={choice.response_url}
      >
        {choice.label}
      </a>

      {!isLast && isInline && <span style={{ color: 'inherit' }}>|</span>}
    </li>
  );
};
